import React from 'react';

const Analytics = () => <div><h2>Demographics Analytics</h2><p>Feature coming soon.</p></div>;

export default Analytics; 